import { CampaignsById } from "../modules/campaigns";

export const CampaignsByIdPage = () => {
  return <CampaignsById />;
};
